"use client";

import { serializeJsonLd } from "./utils";

interface JsonLdScriptProps {
    data: unknown;
}

/**
 * Client wrapper so JSON-LD is SSR'd into a real `<script>` tag without also
 * embedding the full rendered script HTML in the RSC Flight payload
 * (`self.__next_f.push` text chunks). Schema is still built on the server and
 * passed in as a prop.
 */
export const JsonLdScript = ({ data }: JsonLdScriptProps) => (
    <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: serializeJsonLd(data) }}
    />
);
